import { CloseIcon1 } from 'assets/icons';
import { GamesState } from 'features/eventPreMatch/interface/sportPrematch';
import { AnimatePresence, motion } from 'framer-motion';
import BottomDrawer from 'shared/components/BottomDrawer';
import BetBuilderBasketFooter from '../BetBuilderBasketFooter';
import BetBuilderBasketHeader from '../BetBuilderBasketHeader';
import './styles.scss';

interface BetbuilderOverviewProps {
	totalOdds: number;
	onAddBetToCoupon: () => void;
	selectedOddsArray: GamesState[];
	handleClick: () => void;
	isShowSelectedBets: boolean;
	onClickRemoveGame: (elem: number) => void;
	clickOnCross: () => void;
	getSelectedOutcomeName: any;
	openDrawer: boolean;
	isMoreThenOneBetbuilderEvent: boolean;
	handleBottomDrawer: () => void;
}

const BetbuilderOverview = ({
	totalOdds,
	onAddBetToCoupon,
	selectedOddsArray,
	handleClick,
	isShowSelectedBets,
	onClickRemoveGame,
	clickOnCross,
	getSelectedOutcomeName,
	openDrawer,
	isMoreThenOneBetbuilderEvent,
	handleBottomDrawer,
}: BetbuilderOverviewProps) => {
	return (
		<BottomDrawer
			lockOnlyOverflow={true}
			isBottomDrawer={openDrawer}
			handleBottomDrawer={handleBottomDrawer}
			drawerBackground="secondary"
			isDrawerHeader={false}
			className="BetBuilderCreator__drawer"
			isDrawerClose={false}
		>
			<>
				<BetBuilderBasketHeader
					totalOdds={totalOdds}
					selectedOddsArray={selectedOddsArray}
					handleClick={handleClick}
					isShowSelectedBets={isShowSelectedBets}
					clickOnCross={clickOnCross}
					isMoreThenOneBetbuilderEvent={isMoreThenOneBetbuilderEvent}
				/>
				<AnimatePresence>
					{isMoreThenOneBetbuilderEvent && isShowSelectedBets && (
						<motion.div
							className="BetbuilderOverview__outcomes"
							initial={{ height: 0, opacity: 0 }}
							animate={{ height: 'auto', opacity: 1 }}
							exit={{ height: 0, opacity: 0 }}
							transition={{ duration: 0.5 }}
						>
							{selectedOddsArray.map((item, index) => (
								<div className="BetbuilderOverview__eventDetail" key={`selectedOddsArray-${index}`}>
									<div className="BetbuilderOverview__eventDetailBody">
										<p className="BetbuilderOverview__gameName">{item.gameName}</p>
										<p className="BetbuilderOverview__outcomeName">{getSelectedOutcomeName(item)}</p>
									</div>
									<CloseIcon1 className="BetbuilderOverview__closeIcon" onClick={() => onClickRemoveGame(item.outcomeId)} />
								</div>
							))}
						</motion.div>
					)}
				</AnimatePresence>
				<BetBuilderBasketFooter
					onAddBetToCoupon={onAddBetToCoupon}
					totalOdds={totalOdds}
					isMoreThenOneBetbuilderEvent={isMoreThenOneBetbuilderEvent}
				/>
			</>
		</BottomDrawer>
	);
};

export default BetbuilderOverview;
